<template>
  <v-dialog
  persistent
  v-model="show"
  max-width="400px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-form v-model="valid">
      <v-container class="modal-pad">
        <v-layout row wrap>
          <v-flex xs12 style="height:40px;">
            <span class="subheading">Please enter an invoice number</span>
          </v-flex>
        </v-layout>
        <v-layout column pt-2>
          <v-flex xs12>
            <v-text-field
            name="invoice_ref_ensure"
            label="Invoice number (required)"
            id="invoice_ref_ensure"
            v-model="addedinvoice_ref"
            type="text"
            autofocus
            ref="focus"
            placeholder=" "
            required
            :rules="[input_required]"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout align-end justify-end row fill-height>
          <v-btn
            style="margin-left:0; margin-right:0;"
            depressed
            color="primary"
            @click="onCloseDialog">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn style="margin-left:0; margin-right:0;"  depressed color="accent" @click="onSaveChanges" :disabled='!valid'>Save</v-btn>
        </v-layout>
      </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'getInvoiceNumber',
  props: {
    invoice: Object,
    value: Boolean
  },
  data () {
    return {
      valid: false,
      addedinvoice_ref: this.invoice.invoice_ref,
      input_required: value => !!value || 'Required.',
      resolve: null,
      reject: null,
      group: this.$store.getters.group
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    show (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  methods: {
    open () {
      // if there is an invoie_ref or we are using autoincrement then pass the validation now
      if (this.addedinvoice_ref || this.group.autoIncrement) {
        return true
      }
      // else lets show the dialog and get an invoice_ref
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    onCloseDialog () {
      this.resolve(false)
      // hide the dialog
      this.show = false
      // and reset the inputs to their original values
      this.addedinvoice_ref = this.invoice.invoice_ref
    },
    onSaveChanges () {
      this.$emit('return-invoice-details', {
        invoice_ref: this.addedinvoice_ref
      })
      this.resolve(true)
      this.show = false
    }
  }

}
</script>
